import axios from 'axios'
import 'es6-promise/auto'
import Vue from 'vue'
import SiteViewComponent from './components/site/SiteViewComponent'
import SiteTableComponent from './components/site/SiteTableComponent'
import SiteGraphComponent from './components/chart/PercentageRecycledChartComponent'
import UserViewComponent from './components/user/UserViewComponent'
import UserTableComponent from './components/user/UserTableComponent'
import UserSiteSelectionComponent from './components/user/UserSiteSelectionComponent.vue'
import DashboardChartsComponent from './components/dashboard/DashboardChartsComponent'

require('./bootstrap')

const defaultViewPreferences = {
    viewUnits: {
        percentage: true,
        amount: false
    },
    visibleFields: {
        activity: true,
        aggregates: true,
        asphalt: true,
        bricks: true,
        bulkyWaste: true,
        canteenOffice: true,
        carrier_name: true,
        concrete: true,
        equipment_type: true,
        ewc_code: true,
        floorCoverings: true,
        glass: true,
        greenWaste: true,
        gypsum: true,
        hazNonConform: true,
        insulation: true,
        jobDistance: true,
        landfill: true,
        liquids: true,
        material_category: true,
        material_description: true,
        mechTreated: true,
        metals: true,
        movement_type: true,
        nonHazNonConform: true,
        order_date: true,
        other: true,
        packagingCard: true,
        packagingPlastic: true,
        paper: true,
        plastic: true,
        plasticNonRecyclable: true,
        project_name: true,
        project_number: true,
        quantity: true,
        rdf: true,
        recycled: true,
        site: true,
        soils: true,
        tilesCeramics: true,
        totalCarbon: true,
        transportCarbon: true,
        treeCount: true,
        tyres: true,
        unit_of_measure: true,
        vehicle_reg: true,
        wasteCarbon: true,
        waste_facility: true,
        weee: true,
        woodNonPackaging: true,
        woodPackaging: true,
    }
}

const app = new Vue({
    el: '#app',
    axios,
    Promise,
    components: {
        DashboardChartsComponent,
        SiteViewComponent,
        SiteTableComponent,
        SiteGraphComponent,
        UserViewComponent,
        UserTableComponent,
        UserSiteSelectionComponent
    },
    data: {
        viewPreferences: (typeof viewPreferences === 'undefined' ? defaultViewPreferences : viewPreferences)
    }
})

const deleteButtons = document.querySelectorAll('.delete-action')

if (deleteButtons) {
    deleteButtons.forEach((button) => {
        const deletePath = button.href

        button.href = '#'

        button.addEventListener('click', (e) => {
            e.preventDefault()

            $('#delete-confirm-modal').modal('show')

            document.querySelector('#delete-confirm').href = deletePath
        })
    })
}


const userEditForm = document.querySelector('form.user-edit-form')

if(userEditForm) {
    const roleSelect = userEditForm.querySelector('select#role')
    const companySelect = userEditForm.querySelector('select#company')
    const companySelectRow = companySelect.parentNode.parentNode
    const superAdminWarning = userEditForm.querySelector('#super-admin-warning')
    const userCreateSubmit = userEditForm.querySelector('[type="submit"]')

    roleSelect.addEventListener('change', (e) => {
        if(e.target.value === '1') {
            companySelectRow.classList.add('d-none')

            superAdminWarning.classList.remove('d-none')

            if(userEditForm.id === 'user-create-form') {
                userCreateSubmit.innerText = 'Create Super Admin'
            }

            userCreateSubmit.classList.remove('btn-primary')
            userCreateSubmit.classList.add('btn-danger')
        }

        else {
            companySelectRow.classList.remove('d-none')

            superAdminWarning.classList.add('d-none')

            if(userEditForm.id === 'user-create-form') {
                userCreateSubmit.innerText = 'Create'
            }

            userCreateSubmit.classList.remove('btn-danger')
            userCreateSubmit.classList.add('btn-primary')
        }
    })
}
